// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__B_JQ5","label":"Section_label__2igIM","contentWrap":"Section_contentWrap__2MUx4","footer":"Section_footer__3kZrH","footerInner":"Section_footerInner__C9Ol_"};